/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Grid,
  Switch,
} from '@mui/material';
import { CheckboxDropdown, CustomStack } from 'modules/common/components';
import styles from 'modules/transactions/components/inner-filter/inner-filter.module.scss';
/**
 * Breakdown window component common for the dashboard component
 * @param {Boolean} isDetailed - State of Detailed toggle
 * @param {*} chartBreakdown - Selected chart breakdown value
 * @param {Array} chartBreakdownList - chart breakdown list
 * @param {Function} handleIsDetailedChange -  Function to set isDetailed state change
 * @param {Function} handleBreakdownChange -  Function to set breakdown state change
 * @param {Boolean} isFocusOnAvailable - state of focus on section hide or show
 * @param {Array} focusOnList - focus on list
 * @param {*} focusOn - Selected focus on value
 * @param {*} focusOnLabel - focus on section label
 *  @param {Function} handleFocusOnChange -  Function to set focus on state change
 * @returns
 */
const BreakdownWindow = ({
  isDetailed,
  chartBreakdown,
  chartBreakdownList,
  handleIsDetailedChange,
  handleBreakdownChange,
  isFocusOnAvailable,
  focusOnList = [],
  focusOn = [],
  focusOnLabel = '',
  handleFocusOnChange = () => {},
  id = '',
}) => (
  <CustomStack cssClassName={styles.innerFilter}>
    <FormControl>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <FormLabel>Breakdown</FormLabel>
        <FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={isDetailed}
                onChange={handleIsDetailedChange}
                id={`${id}-is-detailed`}
              />
            }
            sx={{ '& .css-1cn7wjw-MuiTypography-root': { fontSize: 12 } }}
            label="Details"
          />
        </FormControl>
      </Grid>
      <RadioGroup
        value={chartBreakdown ?? null}
        onChange={handleBreakdownChange}
        id={`${id}-${chartBreakdown}`}
      >
        {chartBreakdownList
          ?.sort((a, b) => a.label.localeCompare(b.label))
          .map((item) => (
            <FormControlLabel
              key={item?.id}
              value={item?.id}
              control={<Radio />}
              label={item?.label}
              sx={{
                my: -0.5,
              }}
            />
          ))}
      </RadioGroup>
    </FormControl>
    {isFocusOnAvailable && (
      <FormControl id={id ? `${id}-focus-on` : ''}>
        <CheckboxDropdown
          options={focusOnList}
          values={focusOn}
          label={focusOnLabel}
          onchange={handleFocusOnChange}
          isOptionEqualTo={(option, value) => option?.id === value?.id}
        />
      </FormControl>
    )}
  </CustomStack>
);
//
export default BreakdownWindow;
